<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-collage-warm-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-collage-warm-xs" class="g-artboard" style="">
      <div style="padding: 0 0 173.3333% 0;"></div>
      <div
        id="g-collage-warm-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-warm-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:4.4423%;margin-top:-17.4px;left:40.431%;width:118px;"
      >
        <p class="g-pstyle0">Cardi B., 2019</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:7.2745%;margin-top:-24.6px;right:2.4996%;width:74px;"
      >
        <p class="g-pstyle1">Shalom</p>
        <p class="g-pstyle1">Harlow,</p>
        <p class="g-pstyle1">2022</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-XS g-aiAbs"
        style="top:4.5455%;right:30.2721%;width:66.0606%;"
      >
        <p class="g-pstyle2">10-ft-longdown-filled gown with</p>
        <p class="g-pstyle2">30,000 burned and dyed feathers</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:38.4329%;margin-top:-24.8px;left:0.4884%;width:75px;"
      >
        <p class="g-pstyle0">Thom</p>
        <p class="g-pstyle0">Browne,</p>
        <p class="g-pstyle0"></p>
      </div>
      <div
        id="g-ai0-5"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:41.1207%;margin-top:-10.2px;right:83.4785%;width:76px;"
      >
        <p class="g-pstyle1">Designer</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-XS g-aiAbs g-aiPointText"
        style="transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);transform-origin: 50% 52.0317057201246%;-webkit-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-webkit-transform-origin: 50% 52.0317057201246%;-ms-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-ms-transform-origin: 50% 52.0317057201246%;top:56.4003%;margin-top:-24.6px;left:78.979%;margin-left:-42px;width:84px;"
      >
        <p class="g-pstyle3">Designer:</p>
        <p class="g-pstyle3">Ralph</p>
        <p class="g-pstyle3">Lauren</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:68.1137%;margin-top:-24.6px;left:5.291%;width:62px;"
      >
        <p class="g-pstyle0">Lady</p>
        <p class="g-pstyle0">Gaga,</p>
        <p class="g-pstyle0">2019</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:90.6311%;margin-top:-17.4px;left:27.0853%;margin-left:-71.5px;width:143px;"
      >
        <p class="g-pstyle3">Designer:</p>
        <p class="g-pstyle3">Brandon Maxwell</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-XS g-aiAbs"
        style="top:87.7622%;left:76.3271%;margin-left:-21.5152%;width:43.0303%;"
      >
        <p class="g-pstyle4">
          The first of four outfits she changed into, live, with a team of
          dancers in tow
        </p>
      </div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-collage-warm-sm" class="g-artboard" style="">
      <div style="padding: 0 0 154.7059% 0;"></div>
      <div
        id="g-collage-warm-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-warm-sm.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:3.3473%;margin-top:-17.4px;left:88.7871%;margin-left:-66.5px;width:133px;"
      >
        <p class="g-pstyle0">Shalom Harlow,</p>
        <p class="g-pstyle0">2022</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:17.8213%;margin-top:-24.6px;left:62.0952%;width:84px;"
      >
        <p class="g-pstyle1">Cardi B.,</p>
        <p class="g-pstyle1">2019</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-SM g-aiAbs"
        style="top:21.5463%;left:92.5283%;width:8.6275%;"
      >
        <p>14-ft-</p>
        <p>long</p>
        <p>bow</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-SM g-aiAbs"
        style="top:28.0101%;left:1.052%;width:12.7451%;"
      >
        <p>10-ft-longdown-</p>
        <p>filled gown with 30,000 burned and dyed feathers</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-SM g-aiAbs g-aiPointText"
        style="transform: matrix(0.9991,0.0413,-0.0413,0.9991,0,0);transform-origin: 50% 52.0316855649137%;-webkit-transform: matrix(0.9991,0.0413,-0.0413,0.9991,0,0);-webkit-transform-origin: 50% 52.0316855649137%;-ms-transform: matrix(0.9991,0.0413,-0.0413,0.9991,0,0);-ms-transform-origin: 50% 52.0316855649137%;top:42.2826%;margin-top:-24.6px;left:38.6586%;margin-left:-73.5px;width:147px;"
      >
        <p class="g-pstyle0">:</p>
        <p class="g-pstyle0">Thom Browne,</p>
        <p class="g-pstyle0"></p>
      </div>
      <div
        id="g-ai1-6"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:44.6401%;margin-top:-10.2px;right:51.1022%;width:76px;"
      >
        <p class="g-pstyle2">Designer</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-SM g-aiAbs g-aiPointText"
        style="transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);transform-origin: 50% 54.8971783835485%;-webkit-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-webkit-transform-origin: 50% 54.8971783835485%;-ms-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-ms-transform-origin: 50% 54.8971783835485%;top:56.9341%;margin-top:-10.2px;left:73.6093%;margin-left:-88px;width:176px;"
      >
        <p class="g-pstyle0">Designer: Ralph Lauren</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:72.5488%;margin-top:-17.4px;left:5.1419%;width:106px;"
      >
        <p class="g-pstyle1">Lady Gaga,</p>
        <p class="g-pstyle1">2019</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:90.2421%;margin-top:-39px;left:48.2624%;width:151px;"
      >
        <p class="g-pstyle1">The first of four</p>
        <p class="g-pstyle1">outfits she changed</p>
        <p class="g-pstyle1">into, live, with a</p>
        <p class="g-pstyle1">team of dancers in</p>
        <p class="g-pstyle1">tow</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:95.616%;margin-top:-17.4px;left:26.1068%;margin-left:-71.5px;width:143px;"
      >
        <p class="g-pstyle0">Designer:</p>
        <p class="g-pstyle0">Brandon Maxwell</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-collage-warm-md" class="g-artboard" style="">
      <div style="padding: 0 0 145.9091% 0;"></div>
      <div
        id="g-collage-warm-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-warm-md.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:2.2477%;margin-top:-20.6px;left:87.7539%;margin-left:-76px;width:152px;"
      >
        <p class="g-pstyle0">Shalom Harlow,</p>
        <p class="g-pstyle0">2022</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:14.5426%;margin-top:-29px;left:63.0966%;width:94px;"
      >
        <p class="g-pstyle1">Cardi B.,</p>
        <p class="g-pstyle1">2019</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-MD g-aiAbs"
        style="top:21.8069%;left:93.0571%;width:6.6667%;"
      >
        <p>14-ft-</p>
        <p>long</p>
        <p>bow</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:31.9465%;margin-top:-62.6px;left:0.4322%;width:115px;"
      >
        <p class="g-pstyle1">10-ft-long,</p>
        <p class="g-pstyle1">down-filled</p>
        <p class="g-pstyle1">gown with</p>
        <p class="g-pstyle1">30,000</p>
        <p class="g-pstyle1">burned</p>
        <p class="g-pstyle1">and dyed</p>
        <p class="g-pstyle1">feathers</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-MD g-aiAbs g-aiPointText"
        style="transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);transform-origin: 50% 51.814139302513%;-webkit-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-webkit-transform-origin: 50% 51.814139302513%;-ms-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-ms-transform-origin: 50% 51.814139302513%;top:41.2836%;margin-top:-27.6px;left:40.6749%;margin-left:-66px;width:132px;"
      >
        <p class="g-pstyle2">:</p>
        <p class="g-pstyle2">Thom Browne,</p>
        <p class="g-pstyle2">Designer</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-MD g-aiAbs g-aiPointText"
        style="transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:56.5156%;margin-top:-12.2px;left:74.2852%;margin-left:-101px;width:202px;"
      >
        <p class="g-pstyle0">Designer: Ralph Lauren</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:72.9226%;margin-top:-12.2px;left:1.0467%;width:153px;"
      >
        <p class="g-pstyle1">Lady Gaga, 2019</p>
      </div>
      <div
        id="g-ai2-8"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:91.1573%;margin-top:-45.8px;left:49.8627%;width:172px;"
      >
        <p class="g-pstyle1">The first of four</p>
        <p class="g-pstyle1">outfits she changed</p>
        <p class="g-pstyle1">into, live, with a</p>
        <p class="g-pstyle1">team of dancers in</p>
        <p class="g-pstyle1">tow</p>
      </div>
      <div
        id="g-ai2-9"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:97.3256%;margin-top:-12.2px;left:12.1807%;width:236px;"
      >
        <p class="g-pstyle1">Designer: Brandon Maxwell</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-collage-warm-lg" class="g-artboard" style="">
      <div style="padding: 0 0 142.4731% 0;"></div>
      <div
        id="g-collage-warm-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-warm-lg.jpg);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:4.4713%;margin-top:-12.2px;left:81.0781%;width:193px;"
      >
        <p class="g-pstyle0">Shalom Harlow, 2022</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:14.6147%;margin-top:-20.6px;left:61.6575%;width:134px;"
      >
        <p class="g-pstyle0">Cardi B., 2019</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-LG g-aiAbs"
        style="top:25.8113%;left:92.0439%;width:8.8172%;"
      >
        <p>14-ft-long bow</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:31.0374%;margin-top:-54.2px;left:1.4144%;width:134px;"
      >
        <p class="g-pstyle0">10-ft-long,</p>
        <p class="g-pstyle0">down-filled</p>
        <p class="g-pstyle0">gown with</p>
        <p class="g-pstyle0">30,000 burned</p>
        <p class="g-pstyle0">and dyed</p>
        <p class="g-pstyle0">feathers</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-LG g-aiAbs g-aiPointText"
        style="transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);transform-origin: 50% 54.4008939315799%;-webkit-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-webkit-transform-origin: 50% 54.4008939315799%;-ms-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-ms-transform-origin: 50% 54.4008939315799%;top:42.5933%;margin-top:-11.4px;left:41.3619%;margin-left:-98.5px;width:197px;"
      >
        <p class="g-pstyle1">Designer: Thom Browne</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-LG g-aiAbs g-aiPointText"
        style="transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:57.0751%;margin-top:-12.2px;left:75.8811%;margin-left:-101px;width:202px;"
      >
        <p class="g-pstyle2">Designer: Ralph Lauren</p>
      </div>
      <div
        id="g-ai3-7"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:75.0374%;margin-top:-12.2px;left:6.2729%;width:153px;"
      >
        <p class="g-pstyle0">Lady Gaga, 2019</p>
      </div>
      <div
        id="g-ai3-8"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:91.7619%;margin-top:-45.8px;left:51.805%;width:172px;"
      >
        <p class="g-pstyle0">The first of four</p>
        <p class="g-pstyle0">outfits she changed</p>
        <p class="g-pstyle0">into, live, with a</p>
        <p class="g-pstyle0">team of dancers in</p>
        <p class="g-pstyle0">tow</p>
      </div>
      <div
        id="g-ai3-9"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:98.9619%;margin-top:-12.2px;left:13.8395%;width:236px;"
      >
        <p class="g-pstyle0">Designer: Brandon Maxwell</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xl -->
  {#if width && width >= 1200}
    <div id="g-collage-warm-xl" class="g-artboard" style="">
      <div style="padding: 0 0 133% 0;"></div>
      <div
        id="g-collage-warm-xl-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-warm-xl.jpg);"
      ></div>
      <div
        id="g-ai4-1"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:2.8058%;margin-top:-13.8px;left:77.4729%;width:217px;"
      >
        <p class="g-pstyle0">Shalom Harlow, 2022</p>
      </div>
      <div
        id="g-ai4-2"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:12.9937%;margin-top:-23.4px;left:59.7043%;width:150px;"
      >
        <p class="g-pstyle0">Cardi B., 2019</p>
      </div>
      <div
        id="g-ai4-3"
        class="g-XL g-aiAbs"
        style="top:24.4987%;left:87.8354%;width:8.3333%;"
      >
        <p>14-ft-long bow</p>
      </div>
      <div
        id="g-ai4-4"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:29.4975%;margin-top:-61.8px;left:2.2067%;width:150px;"
      >
        <p class="g-pstyle0">10-ft-long,</p>
        <p class="g-pstyle0">down-filled</p>
        <p class="g-pstyle0">gown with</p>
        <p class="g-pstyle0">30,000 burned</p>
        <p class="g-pstyle0">and dyed</p>
        <p class="g-pstyle0">feathers</p>
      </div>
      <div
        id="g-ai4-5"
        class="g-XL g-aiAbs g-aiPointText"
        style="transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);transform-origin: 50% 53.4167500834168%;-webkit-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-webkit-transform-origin: 50% 53.4167500834168%;-ms-transform: matrix(0.9992,0.0413,-0.0413,0.9992,0,0);-ms-transform-origin: 50% 53.4167500834168%;top:41.6437%;margin-top:-14.6px;left:39.9259%;margin-left:-117.5px;width:235px;"
      >
        <p class="g-pstyle1">Designer: Thom Browne</p>
      </div>
      <div
        id="g-ai4-6"
        class="g-XL g-aiAbs g-aiPointText"
        style="transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);transform-origin: 50% 53.628375026575%;-webkit-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-webkit-transform-origin: 50% 53.628375026575%;-ms-transform: matrix(0.773,-0.6344,0.6344,0.773,0,0);-ms-transform-origin: 50% 53.628375026575%;top:56.3772%;margin-top:-13.8px;left:72.1501%;margin-left:-114px;width:228px;"
      >
        <p class="g-pstyle2">Designer: Ralph Lauren</p>
      </div>
      <div
        id="g-ai4-7"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:74.4223%;margin-top:-13.8px;left:7.2003%;width:172px;"
      >
        <p class="g-pstyle0">Lady Gaga, 2019</p>
      </div>
      <div
        id="g-ai4-8"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:91.0514%;margin-top:-52.2px;left:49.8242%;width:193px;"
      >
        <p class="g-pstyle0">The first of four</p>
        <p class="g-pstyle0">outfits she changed</p>
        <p class="g-pstyle0">into, live, with a</p>
        <p class="g-pstyle0">team of dancers in</p>
        <p class="g-pstyle0">tow</p>
      </div>
      <div
        id="g-ai4-9"
        class="g-XL g-aiAbs g-aiPointText"
        style="top:98.4824%;margin-top:-13.8px;left:13.9338%;width:266px;"
      >
        <p class="g-pstyle0">Designer: Brandon Maxwell</p>
      </div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2025-05-01 11:24 -->

<!-- Generated by ai2html v0.100.0 - 2025-05-01 11:24 -->
<!-- ai file: collage-warm.ai -->
<style lang="scss">
  #g-collage-warm-box,
  #g-collage-warm-box .g-artboard {
    margin: 0 auto;
  }
  #g-collage-warm-box p {
    margin: 0;
  }
  #g-collage-warm-box .g-aiAbs {
    position: absolute;
  }
  #g-collage-warm-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-collage-warm-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-collage-warm-xs {
    position: relative;
    overflow: hidden;
  }
  #g-collage-warm-xs p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-collage-warm-xs .g-pstyle0 {
    height: 14px;
  }
  #g-collage-warm-xs .g-pstyle1 {
    height: 14px;
    text-align: right;
  }
  #g-collage-warm-xs .g-pstyle2 {
    text-align: right;
  }
  #g-collage-warm-xs .g-pstyle3 {
    height: 14px;
    text-align: center;
  }
  #g-collage-warm-xs .g-pstyle4 {
    text-align: center;
  }
  #g-collage-warm-sm {
    position: relative;
    overflow: hidden;
  }
  #g-collage-warm-sm p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-warm-sm .g-pstyle0 {
    height: 14px;
    text-align: center;
  }
  #g-collage-warm-sm .g-pstyle1 {
    height: 14px;
  }
  #g-collage-warm-sm .g-pstyle2 {
    height: 14px;
    text-align: right;
  }
  #g-collage-warm-md {
    position: relative;
    overflow: hidden;
  }
  #g-collage-warm-md p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-warm-md .g-pstyle0 {
    height: 17px;
    text-align: center;
  }
  #g-collage-warm-md .g-pstyle1 {
    height: 17px;
  }
  #g-collage-warm-md .g-pstyle2 {
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-collage-warm-lg {
    position: relative;
    overflow: hidden;
  }
  #g-collage-warm-lg p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-warm-lg .g-pstyle0 {
    height: 17px;
  }
  #g-collage-warm-lg .g-pstyle1 {
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-collage-warm-lg .g-pstyle2 {
    height: 17px;
    text-align: center;
  }
  #g-collage-warm-xl {
    position: relative;
    overflow: hidden;
  }
  #g-collage-warm-xl p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-warm-xl .g-pstyle0 {
    height: 19px;
  }
  #g-collage-warm-xl .g-pstyle1 {
    line-height: 20px;
    height: 20px;
    text-align: center;
  }
  #g-collage-warm-xl .g-pstyle2 {
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
